import { parsePhoneNumber, type CountryCode } from 'libphonenumber-js'

export const formatPhoneNumber = (countryCode: string | null, phoneNumber: string | null, fallback = '--'): string => {
  if (!countryCode || !phoneNumber || phoneNumber.length < 3)
    return phoneNumber ?? fallback

  const fullNumber = '+' + countryCode + phoneNumber
  const countryCodeStr = countryCode === '1' ? 'US' : ''
  const parsed = parsePhoneNumber(fullNumber, countryCodeStr as CountryCode)
  return parsed ? parsed.formatInternational() : `${countryCode} ${phoneNumber}`
}
